import React, { useContext, useEffect, useState } from "react";
import { UserAuthContext } from "../../App";
import { allProductForStoreApi } from "../../Apis/ProductApi";

const WebStoreProducts = () => {
  const {userUid} = useContext(UserAuthContext);
  const [allProductsData, setAllProductData] = useState([]);
  
  const getProducts = async ()=>{
    try{
      const response = await allProductForStoreApi(userUid?.currentUser?.uid);
      if(response && response?.products){
        setAllProductData(response?.products);
      }
    }catch(error){
      console.log("Failed to fetch the product details", error);
    }
  }

  useEffect(()=>{
    if(userUid?.currentUser?.uid){
      getProducts();
    }
  },[userUid?.currentUser?.uid]);

  return (
    <div className="w-full bg-white">
      <div className="container max-w-[1240px] mx-auto w-full h-[780px] flex flex-col">
        <h3 className="w-[82px] h-[27px] font-semibold text-[18px] text-black text-start">
          Products
        </h3>
        <hr className="w-[167px] h-[3px] bg-[#FF6300] text-start mt-[8px]" />
        <div className="w-[1240px] h-[695px] rounded-[10px] mt-[20px] border ">
          <div className="w-full h-full flex flex-wrap gap-[30px] overflow-y-scroll p-[45px]">
          {allProductsData.map((products, index) => (
              <>
                <div key={products.productID} className="bg-white drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] w-[260px] h-[418px] rounded-[10px]">
                  <div className="flex items-center justify-center h-[418px]">
                    <div className="grid justify-center">
                      <button>
                        <img
                          src={products?.images[0]}
                          className="w-[234px] h-[187px] mb-[22px]"
                          alt=""
                        />
                      </button>
                      <hr className="w-[230px] h-[1.5px] bg-white mb-[10px]" />
                      <button className="text-left">
                        <p className="w-[150px] h-[24px] font-semibold mb-[13px]">
                          {products?.productTitle.slice(0,1)}
                        </p>
                      </button>
                      <p className="w-[52px] h-[21px] font-semibold text-[14px] mb-[10px]">
                        ₹{products?.maxPrice}
                      </p>
                      <p className="w-[230px] h-[48px] font-regular mb-[18px]">
                       {products?.shortDesc.slice(0,18)}.{" "}
                      </p>
                      <button className="w-[229px] h-[41px] bg-[#FF6300] rounded-[5px]">
                        <div className="flex items-center justify-center gap-2 text-white">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            class="feather feather-send"
                          >
                            <line x1="22" y1="2" x2="11" y2="13"></line>
                            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                          </svg>
                          <p>Send Enquiry</p>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebStoreProducts;
